import { type SelectedMode, type Theme, useTheme } from "../providers";
import { PreferenceGroup, type PreferenceOption, PreferenceSelectRow } from "./preference-rows";

const DISPLAY_MODE_OPTIONS: readonly PreferenceOption<SelectedMode>[] = [
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
  { value: "system", label: "System setting" },
];

const THEME_OPTIONS: readonly PreferenceOption<Theme>[] = [{ value: "green", label: "Green" }];

/** Barbie stays QuoteWell-only. */
const INTERNAL_THEME_OPTION: PreferenceOption<Theme> = { value: "beef", label: "Barbie" };

/**
 * The display mode and theme rows, shared by every app's Settings dialog. The Theme row only appears
 * when there is something to choose: external users have Green alone.
 */
export const AppearancePreferences = ({ internal = false }: { internal?: boolean }) => {
  const { selectedMode, setSelectedMode, setTheme, theme } = useTheme();
  // A shared browser can leave an external user on Barbie; keep it listed so they can switch back to Green.
  const themeOptions =
    internal || theme === INTERNAL_THEME_OPTION.value ? [...THEME_OPTIONS, INTERNAL_THEME_OPTION] : THEME_OPTIONS;

  return (
    <PreferenceGroup heading="Appearance">
      <PreferenceSelectRow
        id="display-mode"
        label="Display mode"
        options={DISPLAY_MODE_OPTIONS}
        value={selectedMode}
        onChange={setSelectedMode}
      />
      {themeOptions.length > 1 && (
        <PreferenceSelectRow id="theme" label="Theme" options={themeOptions} value={theme} onChange={setTheme} />
      )}
    </PreferenceGroup>
  );
};
